import { Component, computed, input } from '@angular/core';
import { MmrService } from '../../../../services/mmr.service';

@Component({
  selector: 'app-view-pr-offer',
  imports: [],
  templateUrl: './view-pr-offer.component.html',
  styleUrl: './view-pr-offer.component.scss',
})
export class ViewPrOfferComponent {
  claimType = input.required<'repair' | 'service'>();

  protected viewModel = computed(() => {
    const { claims } = this.mmrService.planClaimsDetails;
    const claimValue = claims.value()?.[this.claimType()];

    return {
      claimType: this.claimType(),
      claimValue,
    };
  });

  get vm() {
    return this.viewModel();
  }

  constructor(private readonly mmrService: MmrService) {}
}
